<label class="placeholder" [class.touched]="value">{{placeholder}}&nbsp;</label>
<div class="value">{{value}}</div>
<div class="arrow"></div>
<ng-template>
    <div class="drop-down">
        <ng-content></ng-content>
    </div>
</ng-template>